// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 763) return "static/chunks/763-46452040ab9923a7.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + "bbeae641319527f2" + ".js";
};